import React, { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import Input from '../../shared/components/FormElements/Input'
//import Button from '../../shared/components/UIElements/Button'
import AdminButton from '../../shared/components/UIElements/AdminButton'
import { VALIDATOR_REQUIRE } from '../../shared/util/validators'
import './NewPlayerForm.css'
import AdminNavigation from '../../admin/components/AdminNavigation'
import { useForm } from '../../shared/hooks/form-hook'
import { useHttpClient } from '../../shared/hooks/http-hook'
import LoadingSpinner from '../../shared/components/UIElements/LoadingSpinner'
import ErrorModal from '../../shared/components/UIElements/ErrorModal'
import ImageUpload from '../../shared/components/FormElements/ImageUpload'

const Pic1PhotoForm = () => {
	console.log('inside Pic1PhotoForm')
	const { isLoading, error, sendRequest, clearError } = useHttpClient()
	const [file, setFile] = useState()
	const rosterPlayerId = useParams().playerId //This is the rosterPlayer id
	let navigate = useNavigate()

	//only need setFormData in Update
	const [formState, inputHandler, setFormData] = useForm()
	//
	//
	//
	const onFileChange = (e) => {
		let pickedFile

		if (e.target.files && e.target.files.length === 1) {
			pickedFile = e.target.files[0]
			console.log('pickedFile: ' + pickedFile)
			setFile(pickedFile)
		}
	}
	//
	//
	//Next, we want to make a call to uploadPhoto within the player-controller
	const pic1SubmitHandler = async (event) => {
		console.log('inside pic1SubmitHandler ' + formState.inputs)
		event.preventDefault()
		try {
			const formData = new FormData()

			formData.append('image', formState.inputs.image.value)
			const responseData = await sendRequest(
				process.env.REACT_APP_BACKEND_URL + `/admin/uploadPic1Photo`,
				'POST',
				formData
			)
			navigate(`/`)
		} catch (err) {
			console.log('upload pic1 error: ' + err)
		}
	}

	if (isLoading) {
		return (
			<div className='center'>
				<LoadingSpinner />
			</div>
		)
	}

	return (
		<React.Fragment>
			<ErrorModal error={error} onClear={clearError} />
			{!isLoading && (
				<div>
					<AdminNavigation />
					<main>
						<h2>Pic 1</h2>

						<form className='team-form' onSubmit={pic1SubmitHandler}>
							<ImageUpload
								center
								id='image'
								//name='image'
								onInput={inputHandler}
							/>
							<AdminButton type='submit'>ADD PHOTO</AdminButton>
						</form>
					</main>
				</div>
			)}
		</React.Fragment>
	)
}

export default Pic1PhotoForm
